<template>
    <div>
        <div class="top-box">
            <el-row>
                <el-col :span="18" :offset="3">
                    <div class="head-box">
                        <div class="header-left">
                            <img src="../assets/logo.png" alt="" srcset="" width="220" height="64">
                            <img src="../assets/icon/phone.png" alt="" srcset="" width="36" height="36" style="margin-left: 20px;">
                            <span></span>
                            <b>133 8116 1376</b>
                        </div>
                        <div class="header-right">
                            <div @click="scrollToAnchor('home')">
                                <h4 :class="value == 'home' ? 'seleted' : ''">首页</h4>
                                <p>HOME</p>
                            </div>
                            <div @click="scrollToAnchor('applocation')">
                                <h4 :class="value == 'applocation' ? 'seleted' : ''">案例展示</h4>
                                <p>APPLICATION</p>
                            </div>
                            <div @click="scrollToAnchor('certificate')">
                                <h4 :class="value == 'certificate' ? 'seleted' : ''">荣誉资质</h4>
                                <p>CERTIFICATE</p>
                            </div>
                            <div @click="scrollToAnchor('aboutUs')">
                                <h4 :class="value == 'aboutUs' ? 'seleted' : ''">关于我们</h4>
                                <p>ABOUT US</p>
                            </div>
                            <div @click="toNewsList">
                                <h4>新闻</h4>
                                <p>NEWS</p>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div style="height: 124px;"></div>
    </div>
</template>

<script>
import { EventBus } from '../js/eventBus.js';
export default {
    name: 'Header',
    data() {
        return {
            value: 'home'
        }
    },
    methods: {
        scrollToAnchor(str) {
            this.value = str;
            if (str == 'home' || str == 'certificate') {
                this.$emit('home', str)
            } else {
                EventBus.$emit(str, str)
            }

        },

        toNewsList() {
            this.$router.push('/news_list')
        }
    }
}
</script>
<style lang="scss" scoped>
.top-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #FFF;
    z-index: 999;
}

.head-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 0;
}

.header-left {
    display: flex;
    align-items: center;

    span {
        height: 37px;
        background: #D5AF8E;
        width: 1px;
        margin: 0 10px;
    }

    b {
        font-weight: bold;
        font-size: 28px;
        color: #D5AF8E;
        font-style: italic;
    }
}

.header-right {
    display: flex;
    align-items: center;
    text-align: center;
    font-weight: 400;
    justify-content: space-between;
    margin-left: 100px;
    flex: 1;
    cursor: pointer;
    @media (min-width: 1921px) {
        flex: 1000px 0 0!important;
    }
    @media (min-width: 1601px) {
        flex: 800px 0 0!important;
    }
    h4 {
        font-size: 18px;
        color: #2F2F2F;
    }

    p {
        font-size: 12px;
        color: #AD7F5A;
    }
}

.seleted {
    color: #AD7F5A !important;
}
</style>